// Normalizer utility for congregation / church names and general categories

const KNOWN_ACRONYMS: Record<string, string> = {
  KNUST: 'KNUST',
  ARCOC: 'ARCOC',
  UCC: 'UCC',
  UG: 'UG',
  UPSA: 'UPSA',
  ATU: 'ATU',
  UENR: 'UENR',
  UMAT: 'UMaT',
  KTU: 'KTU',
  TTU: 'TTU',
  STU: 'STU',
  HTU: 'HTU',
  CUCG: 'CUCG',
  CSUC: 'CSUC',
  VVU: 'VVU',
  PUC: 'PUC',
  CSIR: 'CSIR',
  GIMPA: 'GIMPA',
};

const CANONICAL_MAP: Record<string, string> = {
  // KNUST
  'knust': 'KNUST Church of Christ',
  'knust church of christ': 'KNUST Church of Christ',
  'knust coc': 'KNUST Church of Christ',

  // ARCOC
  'arcoc': 'Accra Road Church of Christ',
  'accra road': 'Accra Road Church of Christ',
  'accra road church of christ': 'Accra Road Church of Christ',
  'accra road coc': 'Accra Road Church of Christ',

  // Berekum Central
  'berekum': 'Berekum Central Church of Christ',
  'berekum central': 'Berekum Central Church of Christ',
  'berekum central church of christ': 'Berekum Central Church of Christ',
  'berekum central coc': 'Berekum Central Church of Christ',

  // Techiman
  'techiman': 'Techiman Church of Christ',
  'techiman church of christ': 'Techiman Church of Christ',
  'church of christ techiman': 'Techiman Church of Christ',

  // Kintampo Central
  'kintampo central': 'Kintampo Central Church of Christ',
  'kintampo central church of christ': 'Kintampo Central Church of Christ',
  'kintampo central coc': 'Kintampo Central Church of Christ',

  // Kentinkrono
  'kentinkrononsenie': 'Kentinkrono-Nsenie Church of Christ',
  'kentinkrono nsenie': 'Kentinkrono-Nsenie Church of Christ',
  'kentinkrono-nsenie': 'Kentinkrono-Nsenie Church of Christ',
  'kentinkrono': 'Kentinkrono-Nsenie Church of Christ',
  'kentinkrono nsenie church of christ': 'Kentinkrono-Nsenie Church of Christ',
  'kentinkrono-nsenie church of christ': 'Kentinkrono-Nsenie Church of Christ',

  // Boadi
  'boadi': 'Boadi Church of Christ',
  'boadi church of christ': 'Boadi Church of Christ',
  'boadi coc': 'Boadi Church of Christ',

  // Asafo
  'asafo': 'Asafo Church of Christ',
  'asafo coc': 'Asafo Church of Christ',
  'asafo church of christ': 'Asafo Church of Christ',

  // Bantama
  'bantama': 'Bantama Church of Christ',
  'bantama coc': 'Bantama Church of Christ',
  'bantama church of christ': 'Bantama Church of Christ',

  // Domeabra
  'domeabra': 'Domeabra Church of Christ',
  'domeabra coc': 'Domeabra Church of Christ',
  'domeabra church of christ': 'Domeabra Church of Christ',

  // Sarpeh
  'sarpeh': 'Sarpeh Church of Christ',
  'sarpeh coc': 'Sarpeh Church of Christ',
  'sarpeh church of christ': 'Sarpeh Church of Christ',

  // Hwidiem
  'hwidiem': 'Hwidiem Church of Christ',
  'hwidiem church of christ': 'Hwidiem Church of Christ',
  'hwidiem coc': 'Hwidiem Church of Christ',

  // Adankwame
  'adankwame': 'Adankwame Church of Christ',
  'adankwame church of christ': 'Adankwame Church of Christ',
  'adankwame coc': 'Adankwame Church of Christ',

  // Oforikrom / Oforikurom
  'oforikrom': 'Oforikrom Church of Christ',
  'oforikurom': 'Oforikrom Church of Christ',
  'oforikrom coc': 'Oforikrom Church of Christ',
  'oforikurom coc': 'Oforikrom Church of Christ',
  'oforikrom church of christ': 'Oforikrom Church of Christ',
  'oforikurom church of christ': 'Oforikrom Church of Christ',

  // Ohwim-Amanfrom
  'ohwimamanfrom': 'Ohwim-Amanfrom Church of Christ',
  'ohwim amanfrom': 'Ohwim-Amanfrom Church of Christ',
  'ohwim-amanfrom': 'Ohwim-Amanfrom Church of Christ',
  'ohwim amanfrom church of christ': 'Ohwim-Amanfrom Church of Christ',

  // Effiduase
  'effiduase': 'Effiduase Church of Christ',
  'effiduase coc': 'Effiduase Church of Christ',
  'effiduase church of christ': 'Effiduase Church of Christ',

  // Juaben
  'juaben': 'Juaben Church of Christ',
  'juaben coc': 'Juaben Church of Christ',
  'juaben church of christ': 'Juaben Church of Christ',

  // Kotei
  'kotei': 'Kotei Church of Christ',
  'kotei coc': 'Kotei Church of Christ',
  'kotei church of christ': 'Kotei Church of Christ',

  // Obuasi Central
  'obuasi central': 'Obuasi Central Church of Christ',
  'obuasi central church of christ': 'Obuasi Central Church of Christ',
  'obuasi central coc': 'Obuasi Central Church of Christ',

  // Mampong Central
  'mampong central': 'Mampong Central Church of Christ',
  'mampong central church of christ': 'Mampong Central Church of Christ',
  'mampong central coc': 'Mampong Central Church of Christ',

  // Asonkore
  'asonkore': 'Asonkore Church of Christ',
  'asonkore church of christ': 'Asonkore Church of Christ',
  'asonkore coc': 'Asonkore Church of Christ',

  // UST / USted
  'usted': 'KNUST Church of Christ',
  'usted coc': 'KNUST Church of Christ',
  'ust coc': 'KNUST Church of Christ',
  'ust': 'KNUST Church of Christ',

  // True Faith
  'true faith': 'True Faith Church of Christ',
  'true faith church of christ': 'True Faith Church of Christ',
};

export const isChurchField = (fieldName?: string, fieldLabel?: string): boolean => {
  const target = `${fieldName || ''} ${fieldLabel || ''}`.toLowerCase().trim();
  if (!target) return false;
  const keywords = ['congregation', 'church', 'assembly', 'parish', 'fellowship', 'denomination'];
  return keywords.some(kw => target.includes(kw));
};

export const normalizeChurchName = (name?: string | null): string => {
  if (!name) return 'Unspecified';
  const trimmed = name.trim();
  if (!trimmed || /^(unspecified|n\/a|none)$/i.test(trimmed)) {
    return 'Unspecified';
  }

  // Replace multiple spaces and dashes
  let clean = trimmed.replace(/\s+/g, ' ').replace(/[–—]/g, '-');
  clean = clean.replace(/^[ \t\n\r".,']+|[ \t\n\r".,']+$/g, '');

  const lower = clean.toLowerCase();

  // Strip special characters for key lookup
  const lookupKey = lower.replace(/[^\p{L}\p{N}\s-]/gu, '').replace(/\s+/g, ' ').trim();
  if (CANONICAL_MAP[lookupKey]) {
    return CANONICAL_MAP[lookupKey];
  }

  const lookupKeyNoHyphen = lookupKey.replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
  if (CANONICAL_MAP[lookupKeyNoHyphen]) {
    return CANONICAL_MAP[lookupKeyNoHyphen];
  }

  // Rearrange "Church of Christ Techiman" -> "Techiman Church of Christ"
  const churchOfChristPrefix = /^church\s+of\s+christ\s+(.+)$/i.exec(clean);
  if (churchOfChristPrefix && churchOfChristPrefix[1]) {
    return normalizeChurchName(`${churchOfChristPrefix[1].trim()} Church of Christ`);
  }

  // Convert "coc", "c.o.c" to "Church of Christ"
  clean = clean.replace(/\bc\.?o\.?c\.?\b/gi, 'Church of Christ');

  const minorWords = new Set(['of', 'and', 'the', 'in', 'at', 'on', 'for', 'to', 'de', 'du']);
  const tokens = clean.split(/(\s+|-)/);

  let formatted = '';
  for (const token of tokens) {
    if (token === '-' || /^\s+$/.test(token)) {
      formatted += token;
      continue;
    }

    const upper = token.toUpperCase();
    const lowerToken = token.toLowerCase();

    if (KNOWN_ACRONYMS[upper]) {
      formatted += KNOWN_ACRONYMS[upper];
    } else if (minorWords.has(lowerToken) && formatted !== '') {
      formatted += lowerToken;
    } else {
      formatted += lowerToken.charAt(0).toUpperCase() + lowerToken.slice(1);
    }
  }

  formatted = formatted.replace(/\bChurch\s+Of\s+Christ\b/gi, 'Church of Christ');
  return formatted.trim();
};
